// Marketplace rate-card data. Every value is INDICATIVE — actual marketplace
// fees vary by category, seller tier, weight, fulfilment and account-specific
// terms. Sources listed per marketplace. Update `lastUpdated` when refreshed.

export const MARKETPLACES_RATES = [
  {
    id: "amazon",
    name: "Amazon India",
    logo: null,
    lastUpdated: "2026-01-15",
    sourceUrl: "https://sell.amazon.in/pricing",
    disclaimer: "Amazon India fees vary by category, price band, weight and fulfilment. Numbers below are indicative — always confirm with the Amazon Fee Preview report in Seller Central.",
    referralPct: 12,
    closingFeeFlat: 30,
    fulfilmentFeeFlat: 55,
    weightFeePerKg: 30,
    hasFBA: true,
    ratePresets: {
      "Beauty & Personal Care": 15,
      "F&B / Grocery": 8,
      "Home & Kitchen": 15,
      "Fashion Apparel": 24,
      "Fashion Accessories": 15,
      "Electronics": 8,
      "Wellness / Nutraceuticals": 15,
      "Baby": 15,
      "Sports & Fitness": 15
    }
  },
  {
    id: "flipkart",
    name: "Flipkart",
    logo: null,
    lastUpdated: "2026-01-15",
    sourceUrl: "https://seller.flipkart.com/",
    disclaimer: "Flipkart rates below are indicative. Seller-specific rates and category-specific rates should be checked inside Flipkart Seller Hub.",
    referralPct: 14,
    closingFeeFlat: 35,
    fulfilmentFeeFlat: 60,
    weightFeePerKg: 32,
    hasFBA: true,
    ratePresets: {
      "Fashion Apparel": 24,
      "Home & Kitchen": 14,
      "Beauty & Personal Care": 15,
      "F&B / Grocery": 10,
      "Electronics": 8,
      "Sports & Fitness": 14,
      "Baby": 14,
      "Wellness / Nutraceuticals": 15,
      "Fashion Accessories": 14
    }
  },
  {
    id: "meesho",
    name: "Meesho",
    logo: null,
    lastUpdated: "2026-01-15",
    sourceUrl: "https://supplier.meesho.com/",
    disclaimer: "Meesho charges a low platform commission but adds shipping fees and returns costs. All-in economics require a return-rate assumption.",
    referralPct: 5,
    closingFeeFlat: 0,
    fulfilmentFeeFlat: 45,
    weightFeePerKg: 25,
    hasFBA: false,
    ratePresets: {
      "Fashion Apparel": 5,
      "Home & Kitchen": 5,
      "Beauty & Personal Care": 5,
      "Fashion Accessories": 5,
      "Baby": 5,
      "F&B / Grocery": 5
    }
  },
  {
    id: "jiomart",
    name: "JioMart",
    logo: null,
    lastUpdated: "2026-01-15",
    sourceUrl: "https://partners.jiomart.com/",
    disclaimer: "JioMart commissions vary by category and seller tier. Confirm rates during JioMart onboarding.",
    referralPct: 10,
    closingFeeFlat: 25,
    fulfilmentFeeFlat: 45,
    weightFeePerKg: 25,
    hasFBA: true,
    ratePresets: {
      "F&B / Grocery": 8,
      "Home & Kitchen": 10,
      "Beauty & Personal Care": 12,
      "Fashion Apparel": 15,
      "Wellness / Nutraceuticals": 12,
      "Baby": 10
    }
  },
  {
    id: "myntra",
    name: "Myntra",
    logo: null,
    lastUpdated: "2026-01-15",
    sourceUrl: "https://partners.myntra.com/",
    disclaimer: "Myntra commissions are category and brand-tier specific.",
    referralPct: 25,
    closingFeeFlat: 40,
    fulfilmentFeeFlat: 70,
    weightFeePerKg: 30,
    hasFBA: true,
    ratePresets: {
      "Fashion Apparel": 25,
      "Fashion Accessories": 22,
      "Sports & Fitness": 22
    }
  },
  {
    id: "nykaa",
    name: "Nykaa",
    logo: null,
    lastUpdated: "2026-01-15",
    sourceUrl: "https://sellers.nykaa.com/",
    disclaimer: "Nykaa commissions are category and brand-tier specific.",
    referralPct: 25,
    closingFeeFlat: 40,
    fulfilmentFeeFlat: 70,
    weightFeePerKg: 30,
    hasFBA: true,
    ratePresets: {
      "Beauty & Personal Care": 25,
      "Wellness / Nutraceuticals": 22
    }
  },
  {
    id: "ajio",
    name: "AJIO",
    logo: null,
    lastUpdated: "2026-01-15",
    sourceUrl: "https://partners.ajio.com/",
    disclaimer: "AJIO commissions are category and brand-tier specific.",
    referralPct: 24,
    closingFeeFlat: 40,
    fulfilmentFeeFlat: 70,
    weightFeePerKg: 30,
    hasFBA: true,
    ratePresets: { "Fashion Apparel": 24, "Fashion Accessories": 22 }
  },
  {
    id: "tatacliq",
    name: "Tata CLiQ",
    logo: null,
    lastUpdated: "2026-01-15",
    sourceUrl: "https://sell.tatacliq.com/",
    disclaimer: "Tata CLiQ commissions are category and brand-tier specific.",
    referralPct: 22,
    closingFeeFlat: 40,
    fulfilmentFeeFlat: 70,
    weightFeePerKg: 30,
    hasFBA: true,
    ratePresets: {
      "Fashion Apparel": 22,
      "Home & Kitchen": 15,
      "Beauty & Personal Care": 22
    }
  },
  {
    id: "blinkit",
    name: "Blinkit",
    logo: null,
    lastUpdated: "2026-01-15",
    sourceUrl: "https://blinkit.com/partner",
    disclaimer: "Quick-commerce commissions are set per-brand at negotiation. Rates below are indicative.",
    referralPct: 20,
    closingFeeFlat: 15,
    fulfilmentFeeFlat: 25,
    weightFeePerKg: 0,
    hasFBA: true,
    ratePresets: { "F&B / Grocery": 18, "Beauty & Personal Care": 22, "Home & Kitchen": 22 }
  },
  {
    id: "zepto",
    name: "Zepto",
    logo: null,
    lastUpdated: "2026-01-15",
    sourceUrl: "https://www.zeptonow.com/",
    disclaimer: "Quick-commerce commissions are set per-brand at negotiation.",
    referralPct: 18,
    closingFeeFlat: 15,
    fulfilmentFeeFlat: 25,
    weightFeePerKg: 0,
    hasFBA: true,
    ratePresets: { "F&B / Grocery": 16, "Beauty & Personal Care": 20, "Home & Kitchen": 20 }
  },
  {
    id: "instamart",
    name: "Instamart",
    logo: null,
    lastUpdated: "2026-01-15",
    sourceUrl: "https://partner.swiggy.com/",
    disclaimer: "Quick-commerce commissions are set per-brand at negotiation.",
    referralPct: 20,
    closingFeeFlat: 15,
    fulfilmentFeeFlat: 25,
    weightFeePerKg: 0,
    hasFBA: true,
    ratePresets: { "F&B / Grocery": 18, "Beauty & Personal Care": 20, "Home & Kitchen": 20 }
  },
  {
    id: "swiggy",
    name: "Swiggy Mall",
    logo: null,
    lastUpdated: "2026-01-15",
    sourceUrl: "https://partner.swiggy.com/",
    disclaimer: "Swiggy Mall commissions are set per-brand.",
    referralPct: 22,
    closingFeeFlat: 20,
    fulfilmentFeeFlat: 30,
    weightFeePerKg: 0,
    hasFBA: true,
    ratePresets: { "F&B / Grocery": 20, "Beauty & Personal Care": 22, "Home & Kitchen": 22 }
  }
];

export const CATEGORIES = [
  "Beauty & Personal Care",
  "F&B / Grocery",
  "Home & Kitchen",
  "Fashion Apparel",
  "Fashion Accessories",
  "Electronics",
  "Wellness / Nutraceuticals",
  "Baby",
  "Sports & Fitness"
];

// Marketplace calculation engine. Returns settlement, net profit, margin and ROI.
export function calculate(marketplace, inputs) {
  const {
    sellingPrice = 0,
    productCost = 0,
    gstPct = 18,
    category,
    weightKg = 0.5,
    fulfilment = "FBA",
    adCostPerUnit = 0,
    returnRatePct = 5,
    packagingCost = 0
  } = inputs;

  const referralPct = marketplace.ratePresets?.[category] ?? marketplace.referralPct;
  const referralFee = (sellingPrice * referralPct) / 100;
  const closingFee = marketplace.closingFeeFlat || 0;
  const fulfilmentFee = fulfilment === "Self Ship" ? 0 : (marketplace.fulfilmentFeeFlat || 0);
  const weightFee = fulfilment === "Self Ship" ? 0 : (marketplace.weightFeePerKg || 0) * weightKg;

  const totalMarketplaceFees = referralFee + closingFee + fulfilmentFee + weightFee;

  // GST on fees (18%) - typical for services
  const gstOnFees = totalMarketplaceFees * 0.18;

  // Return / RTO impact — assume half return cost per unit sold
  const returnCostPerUnit = (returnRatePct / 100) * (productCost + fulfilmentFee + weightFee);

  const settlement = sellingPrice - totalMarketplaceFees - gstOnFees;
  const netProfit = settlement - productCost - adCostPerUnit - returnCostPerUnit - packagingCost;
  const marginPct = sellingPrice > 0 ? (netProfit / sellingPrice) * 100 : 0;
  const roiPct = productCost > 0 ? (netProfit / productCost) * 100 : 0;

  // Break-even selling price (approx)
  const totalCostFloor = productCost + adCostPerUnit + returnCostPerUnit + packagingCost + closingFee + fulfilmentFee + weightFee;
  const feePct = (referralPct / 100) * 1.18; // include GST on fees
  const breakEvenPrice = feePct < 1 ? totalCostFloor / (1 - feePct) : 0;

  return {
    referralPct,
    referralFee,
    closingFee,
    fulfilmentFee,
    weightFee,
    totalMarketplaceFees,
    gstOnFees,
    settlement,
    netProfit,
    marginPct,
    roiPct,
    breakEvenPrice,
    returnCostPerUnit
  };
}
